import { MagnifyingGlassIcon } from "@phosphor-icons/react";
import pluralize from "pluralize";

import FlexWrapper, { FlexDirection } from "@gx/dls/containers/FlexWrapper";
import HorizontalDivider from "@gx/dls/dividers/HorizontalDivider";
import TextInput from "@gx/dls/inputs/TextInput";
import Text, { TextVariant } from "@gx/dls/text/Text";

import BaseToolbar from "@/layouts/components/BaseToolbar";

interface EditSourceContentToolbarProps {
  search: string;
  count: number;
  onSearchChange: (value: string) => void;
}

const EditSourceContentToolbar = ({
  search,
  count,
  onSearchChange,
}: EditSourceContentToolbarProps) => {
  return (
    <FlexWrapper direction={FlexDirection.COLUMN} fillWidth>
      <FlexWrapper padding="8px 12px" fillWidth>
        <BaseToolbar
          leadingActions={[
            <TextInput
              key="search"
              placeholder="Search"
              leading={{ icon: MagnifyingGlassIcon }}
              width={240}
              onChange={onSearchChange}
              value={search}
            />,
          ]}
          trailingActions={[
            <Text key="count" variant={TextVariant.TERTIARY}>
              {count} {pluralize("item", count)}
            </Text>,
          ]}
        />
      </FlexWrapper>
      <HorizontalDivider />
    </FlexWrapper>
  );
};

export default EditSourceContentToolbar;
